import differenceInYears from "date-fns/differenceInYears";

export function calculateAge(birthday: Date) {
  // birthday is a date
  return differenceInYears(new Date(), birthday);
}
